<template>
    <div class="mt-1">
        <b-form-select
            v-model="selected"
            :options="options"
            size="sm"
            @change="setDeadlineState"
        ></b-form-select>
    </div>
</template>

<script>
export default {
    name: 'SelectDeadlineState',

    props: {
        selectedOption: String,
        page: String,
    },

    data() {
        return {
            selected: 'all',
            options: [{ value: 'all', text: 'Toutes les échéances' }],
            tries: 0,
        }
    },

    created() {
        this.getDeadlineStates()
    },

    methods: {
        async getDeadlineStates() {
            try {
                this.tries++
                const response = await axios.get('/filters/deadlineStates')
                this.options = response.data
                this.selected = this.selectedOption
            } catch (error) {
                // handle error
                console.log(error)
                console.log(this.tries)
                if (this.tries < 3) this.getDeadlineStates()
            }
        },

        async setDeadlineState() {
            try {
                await axios.post(`/filters/deadlineStates/${this.selected}/set`)
                this.$root.$refs.menu.getFilters()
                this.$root.$refs.menu.getCounters()
                this.$root.$refs.menu.updateTable()
            } catch (error) {
                // handle error
                console.log(error)
            }
        },
    },
}
</script>

<style scoped></style>
